import { map } from '@antv/util';
export function getTinyData(data) {
  return map(data || [], function (y, x) {
    return {
      x: "".concat(x),
      y: y
    };
  });
}